export default __webpack_public_path__ + "static/media/footer-logo.f971549e.png";